const IMGS = {
  governor: require("./governor.png"),
  governorTotal: require("./governorTotal.png"),
  governorTotalFrame: require("./governorTotalFrame.png"),
  oilCan: require("./oilCan.png"),
  thermometer: require("./thermometer.png"),
  transTemp: require("./transTemp.png"),
  volts: require("./volts.png"),
};
export default IMGS;
